import { type CarrierDef } from '../common.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  'client-id',
  'client-secret',
] as const

export type tqylCredType = (typeof credentialTypes)[number]
export const tqyl: CarrierDef<tqylCredType> = {
  name: 'Total Quality Logistics',
  scac: 'tqyl',
  credentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['client-id', 'apiKey'],
    ['client-secret', 'apiPassword'], // CRED NOTE - collecting this on the app side, but it's never used in engine services
  ],
  engineLayers: ['rating', 'pickup', 'tracking'],
}
